import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useGoBoldStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "@media (max-width: 540px)": {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },

  title: {
    color: tokens.colorNeutralForeground4,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: tokens.lineHeightBase300,
  },

  category: {
    color: tokens.colorNeutralForeground4,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: tokens.lineHeightBase300,
    alignContent: "end",
  },

  badgeContainer: {
    display: "flex",
    ...shorthands.gap("8px"),
    "@media (max-width: 540px)": {
      display: "inline",
      flexWrap: "wrap",
    },
  },

  badge: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    ...shorthands.gap("4px"),
  },

  visibleTooltipIcon: {
    color: tokens.colorNeutralForeground2BrandSelected,
  },

  alsoWorksInTitleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  tooltipIcon: {
    marginLeft: "4px",
    height: "14px",
    width: "14px",
  },

  helpLink: {
    paddingTop: "0px",
  },

  column: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    "@media (max-width: 540px)": {
      gap: "12px",
    },
  },
});

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    alignSelf: "stretch",
    justifyContent: "space-between",
    ...shorthands.gap("8px"),
    "@media (max-width: 540px)": {
      flexDirection: "column",
    },
  },

  title: {
    color: tokens.colorNeutralForeground2,
    fontSize: "0.75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.375rem",
  },

  category: {
    color: tokens.colorNeutralForeground2,
    fontSize: "0.75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.375rem",
    alignContent: "end",
  },

  badgeContainer: {
    display: "flex",
    ...shorthands.gap("8px"),
    "@media (max-width: 540px)": {
      display: "inline",
      flexWrap: "wrap",
    },
  },

  badge: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    alignSelf: "stretch",
    ...shorthands.gap("8px"),
  },
  visibleTooltipIcon: {
    color: tokens.colorNeutralForeground2BrandSelected,
  },
  alsoWorksInTitleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  tooltipIcon: {
    marginLeft: "4px",
    height: "14px",
    width: "14px",
  },
  helpLink: {
    paddingTop: "12px",
  },
  column: {},
});
